const firebaseConfig = {
  apiKey: "AIzaSyDHDABLs_Joe9VcOSySNyoxYRpXsz_4Nck",
  authDomain: "sigma-central-hospital.firebaseapp.com",
  projectId: "sigma-central-hospital",
  storageBucket: "sigma-central-hospital.appspot.com",
  messagingSenderId: "1056338118917",
  appId: "1:1056338118917:web:91af48540e7545e4180f6c"
};
export default firebaseConfig;